import React from 'react'
import { GlobalContext } from 'components/context'
import { featureEnabled } from 'components/features'

const PTBooking = () => {
  const { locale, env } = React.useContext(GlobalContext)

  if (!featureEnabled('pts', locale, env)) {
    return null
  }

  window.sessionStorage.setItem(
    'pts-token',
    window.localStorage.getItem('token'))

  return (
    <div id={'pt-booking'}>
      <pt-member-booking locale={locale}></pt-member-booking>
    </div>
  )
}

export default PTBooking
